<template>
    <div class="payment-wrapper">
        <div class="payment-header pb-0 px-3 px-lg-0">
            <div class="container">
                <h1 class="payment-title">
                    {{ $t('buying_a_certificate') }}: {{ course.course }}
                </h1>

                <div class="ui-steeps">
                    <ul class="ui-steeps__header">
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                1. {{ $t('order') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-active">
                            <div class="ui-steep-header-item__text">
                                2. {{ $t('payment') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                <span class="d-none d-sm-block">3. {{ $t('payment_information') }}</span>
                                <span class="d-block d-sm-none">3. {{ $t('abput_payment') }}</span>
                            </div>
                        </li>
                    </ul>
                </div><!-- /.ui-steeps -->
            </div><!-- /.container -->
        </div>

        <div class="payment-gateway px-3 px-lg-0">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 v-show="flavorConfig.payConfig.yookassa" class="payment-subtitle">
                            {{ $t('safe_payments_notice') }}
                        </h2>

                        <div class="payment-subtitle-notice">{{ $t('we_do_not_store_pay_data') }}</div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-6 order-2 order-lg-1 payment-pay-widget-wrapper">
                        <div v-if="!!notification" class="text-center">
                            <span style="color: red;">
                                {{ $t('promocode_failed') }}:<br/> {{ notification }} <br/><br/>
                            </span>
                            {{ $t('promocode_failed_title') }}:
                            <div class="text-left mx-auto" style="width: 70%">
                                <ul>
                                    <li>{{ $t('promocode_failed_1') }};</li>
                                    <li>{{ $t('promocode_failed_2') }};</li>
                                    <li>{{ $t('promocode_failed_3') }}.</li>
                                </ul>
                            </div>
                        </div>

                        <p v-if="discount>0" class="text-center mb-1">
                            {{ $t('promocode_discount', { discount: discount }) }}<br/>
                            <span class="cena">{{ $t('promocode_total_price', { price: price }) }}</span>
                        </p>

                        <pay-widget
                                :item="payItem"
                                @captured="paymentCaptured"
                        />

                    </div>
                    <div class="col-12 col-lg order-1 order-lg-2 mb-lg-0 mb-3">
                        <div class="row d-flex flex-wrap align-items-center">
                            <div class="col-lg-12 col-4 text-lg-right text-center">
                                <img src="poliimg/visa-verified.png" class="img-fluid mb-lg-5">
                            </div>
                            <div v-show="!flavorConfig.payConfig.revolut" class="col-lg-12 col-4 text-lg-right text-center">
                                <img src="poliimg/mir-accept.png" class="img-fluid mb-lg-5">
                            </div>
                            <div class="col-lg-12 col-4 text-lg-right text-center">
                                <img src="poliimg/mastercard-securecode.png" class="img-fluid mb-lg-5">
                            </div>
                        </div>
                    </div>
                </div><!-- /.container -->
            </div>
        </div>

        <div class="container">
            <div class="row text-center mt-5 justify-content-center">
                <div class="col-12">{{ $t('certificate_to_name') }}:</div>
                <div class="col-12 col-lg-8 cert_name">{{ cert_name }}</div>
                <div class="col-12 mt-4">{{ $t('wish_text_on_the_certificate') }}:</div>
                <div class="col-12  col-lg-8 cert_text">{{ cert_text }}</div>
                <div class="col-12 mt-7">{{ $t('course') }}:</div>
            </div>
        </div>

        <div class="payment-course">
            <div class="container">
                <course-list-item
                        :course="course"
                        :hideButton="true"
                        :hideAdd="!$route.query.hasOwnProperty('add')"
                        :hideAddSwitch="true"
                        :activated="$route.query.hasOwnProperty('add')"
                />


            </div><!-- /.container -->
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import PayWidget from '@/components/PayWidget.vue'
    import CourseListItem from "../CourseListItem";
    import CStorage from "../../data/CStorage";

    export default {
        name: 'payment',
        props: ['id'],
        components: {
            PayWidget,
            CourseListItem,
        },
        data() {
            return {
                course: {},
                loading: false,
                paySystem: 'yookassa',
                notification: '',
                discount: 0,
                price: null,

                payItem: {},

                cert_name: null,
                cert_text: null,

                phone: null,
                comment: null,
            }
        },
        mounted() {

            this.cert_name = CStorage.getItem('ORD_CERT_cert_name', this.cert_name)
            this.cert_text = CStorage.getItem('ORD_CERT_cert_text', this.cert_text)

            this.phone = CStorage.popItem('ORD_CERT_phone')
            this.comment = CStorage.popItem('ORD_CERT_comment')

            axios({method: 'get', url: '/courses/' + this.id}).then(response => {
                this.course = response.data
                let price = response.data.price

                let client_id = ''
                if (this.$metrika && this.$metrika.getClientID()) client_id = this.$metrika.getClientID()

                const params = {
                    confirmation_type: 'embedded',
                    promocode: this.$route.query.promocode,
                    price: price,
                    description: response.data.course,
                    idcertcourse: response.data.idcourse,
                    client_id: client_id,
                    cert_name: this.cert_name,
                    cert_text: this.cert_text,
                    phone: this.phone,
                    comment: this.comment,
                }

                axios({method: 'post', url: '/payment', data: params}).then(payresponse => {
                    console.log(payresponse.data)
                    if (payresponse.data.log && payresponse.data.log.length) this.notification = payresponse.data.log.join('<br/>')
                    this.price = payresponse.data.userpayment.price
                    this.discount = this.course.price - payresponse.data.userpayment.price

                    if (payresponse.data.userpayment.price <= 0) {
                        this.$router.push('/paymentstatus/free?idcertcourse=' + this.id)
                    }

                    this.payItem = {
                        user_payment_id: payresponse.data.userpayment.id,
                        confirmation_type: 'embedded',
                        promocode: this.$route.query.promocode,
                        price: this.price,
                        description: response.data.course,
                        idcertcourse: response.data.idcourse,
                        client_id: client_id,
                        cert_name: this.cert_name,
                        cert_text: this.cert_text,
                        paypalClientId: payresponse.data.paypal_client_id,
                        phone: this.phone,
                        comment: this.comment,
                    }

                })
            })

            this.loading = false
        },

        methods: {
            paymentCaptured(data) {
                this.$router.push('/paymentstatus/' + this.payItem.user_payment_id)
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },


        }
    };
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>

<style>
    .cert_name, .cert_text {
        font-family: 'Manrope Bold', 'Open Sans', sans-serif;
        font-size: 19px;
    }
</style>
